import { Drawer, AppBar as MuiAppBar, styled } from "@mui/material";
import { Button } from "@totalsoft/rocket-ui";
import { drawerMiniWidth, drawerWidth } from "assets/jss/styles";

export const AppBar = styled(MuiAppBar)(({ theme }) => ({
  borderBottom: "0",
  marginBottom: "0",
  width: "100%",
  zIndex: "1029",
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.background.default,
  border: "0",
  borderRadius: "3px",
  transition: "all 150ms ease 0s",
  minHeight: "50px",
  display: "block",
  boxShadow: `0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px ${theme.palette.primary.main}`,
  "@media (max-width: 80px)": {
    position: "relative",
    backgroundColor: `${theme.palette.background.default} !important`,
    padding: 0
  }
}));

export const HeaderTitleContainer = styled("div")(({ theme }) => ({
  lineHeight: "50px",
  fontSize: "18px",
  fontWeight: "bold",
  borderRadius: "3px",
  textTransform: "none",
  color: theme.palette.primary.main,
  display: "flex",
  flexGrow: 1,
  justifyContent: "space-between",
  "&:hover,&:focus": {
    background: "transparent"
  },
  padding: "8px 16px",
  "@media (max-width: 480px)": {
    padding: 0
  }
}));

export const SideButton = styled(Button)(() => ({
  position: "absolute",
  right: 0,
  color: "white",
  top: "35px",
  transform: "rotate(-90deg)",
  transformOrigin: "100% 100%",
  marginRight: "-3px",
  "@media (max-width: 480px)": {
    top: "-100px"
  }
}));

export const MainContainer = styled("div")(() => ({
  paddingRight: "15px",
  paddingLeft: "15px",
  marginRight: "auto",
  marginLeft: "auto",
  "&:before,&:after": {
    display: "table",
    content: '" "'
  },
  "&:after": {
    clear: "both"
  }
}));

export const MainContent = styled("div")(() => ({
  padding: ".5rem"
}));

export const SidebarDrawer = styled(Drawer, {
  shouldForwardProp: prop => prop !== "miniActive"
})(({ theme, miniActive }) => {
  let miniAttributes = {};
  if (miniActive) miniAttributes = { width: drawerMiniWidth + "px !important" };

  return {
    "& .MuiDrawer-paper": {
      border: "none",
      position: "fixed",
      top: "0",
      bottom: "0",
      left: "0",
      zIndex: "1032",
      transitionProperty: "top, bottom, width",
      transitionDuration: ".2s, .2s, .35s",
      transitionTimingFunction: "linear, linear, ease",
      boxShadow:
        "0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
      width: drawerWidth,
      color: theme.palette.primary.main,
      ...miniAttributes,
      [theme.breakpoints.up("md")]: {
        width: drawerWidth,
        position: "fixed",
        height: "100%"
      },
      [theme.breakpoints.down("md")]: {
        width: drawerWidth,
        boxShadow:
          "0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
        position: "fixed",
        display: "block",
        top: "0",
        height: "100vh",
        right: "0",
        left: "auto",
        zIndex: "1032",
        visibility: "visible",
        overflowY: "visible",
        borderTop: "none",
        textAlign: "left",
        paddingRight: "0px",
        paddingLeft: "0",
        transform: `translate3d(${drawerWidth}px, 0, 0)`,
        transition: "all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
      },
      "&:after": {
        content: "''",
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        backgroundColor: theme.palette.sideMenu.bgColor,
        opacity: theme.palette.sideMenu.bgOpacity
      }
    }
  };
});

export const SidebarWrapperContainer = styled("div", {
  shouldForwardProp: prop => prop !== "miniActive" && prop !== "withOverflowHidden"
})(({ miniActive, withOverflowHidden, theme }) => {
  let miniAttributes = {};
  if (miniActive) miniAttributes = { width: drawerMiniWidth + "px !important" };

  let overflowHiddenAttributes = {};
  if (withOverflowHidden)
    overflowHiddenAttributes = {
      overflow: "hidden !important"
    };

  return {
    position: "relative",
    height: "calc(100vh - 75px)",
    overflow: "auto",
    width: "260px",
    zIndex: "4",
    overflowScrolling: "touch",
    transitionProperty: "top, bottom, width",
    transitionDuration: ".2s, .2s, .35s",
    transitionTimingFunction: "linear, linear, ease",
    fontFamily: theme.typography.fontFamily,
    color: "inherit",
    paddingBottom: "30px",
    ...miniAttributes,
    ...overflowHiddenAttributes
  };
});

export const SidebarLogoContainer = styled("div")(({ theme }) => ({
  padding: "15px 0px 30px 0",
  margin: "0",
  display: "block",
  position: "relative",
  zIndex: "4",
  "&:after": {
    content: '""',
    position: "absolute",
    bottom: "0",
    height: "1px",
    right: "15px",
    width: "calc(100% - 30px)",
    backgroundColor: theme.palette.primary.main
  }
}));

export const StyledImage = styled("img")(() => ({
  width: "100%",
  verticalAlign: "middle",
  paddingRight: "10px",
  paddingLeft: "10px",
  border: "0"
}));

export const StyledLogoMini = styled("a")(() => ({
  transition: "all 300ms linear",
  opacity: 1,
  maxHeight: "30px",
  marginTop: "7px",
  color: "inherit"
}));

export const StyledLogoDefault = styled("a")(({ theme }) => ({
  ...theme.defaultFont,
  transition: "all 300ms linear",
  display: "block",
  opacity: "1",
  transform: "translate3d(0px, 0, 0)",
  textTransform: "uppercase",
  padding: "5px 0px",
  fontSize: "18px",
  whiteSpace: "nowrap",
  fontWeight: "400",
  lineHeight: "30px",
  overflow: "hidden",
  "&,&:hover,&:focus": {
    color: "inherit"
  }
}));
